<template>
  <div v-if="webhookId" class="webhook-id">
    <div>
      <div>
        <svg-icon :icon-class="'webhook-id'" />
      </div>
      <div class="webhook-id__id-container ellipsis">
        ID #<CopyText :label="ellipsisCenter(webhookId)" :value="webhookId" />
      </div>
    </div>
  </div>
</template>

<script>
import { ellipsisCenter } from '@/utils/index.js'
import CopyText from '@/components/CopyText'
export default {
  components: {
    CopyText,
  },
  data() {
    return {
      ellipsisCenter,
    }
  },
  computed: {
    webhookId() {
      return this.$route.params.webhookId
    },
  },
}
</script>

<style lang="scss" scoped>
.webhook-id {
  display: flex;
  justify-content: flex-end;
  svg {
    width: 18px;
    height: 18px;
    margin: 0 6px;
  }
}

.webhook-id > div {
  display: flex;
  align-items: center;
  margin: 0 25px;
  &:last-child {
    margin-right: 0;
    [dir='rtl'] & {
      margin-left: 0;
    }
  }
}

.webhook-id__id-container {
  display: flex;
  justify-content: center;
}

.webhook-id__id-container > div {
  [dir='rtl'] & {
    direction: rtl;
  }
}
.webhook-id__id-container button {
  margin-bottom: -3px;
}
</style>
